import React from "react";
import { Link, ResponsiveImage } from "@quintype/components";
import CardImage from "../../atoms/card-image";
import { object, number, array } from "prop-types";
import { TimeStamp } from "../../../arrow/components/Atoms/TimeStamp";
import { SectionTag } from "../../../arrow/components/Atoms/SectionTag";
import "./image-type-4.m.css";
import { HeroImage } from "../../../arrow/components/Atoms/HeroImage";
import { useSelector } from "react-redux";
import get from 'lodash/get';
const ImageType4 = ({ story, aspectRatio, showOverlay = false,showTimestamp=false}) => {
  const storyObj = story.story ? story.story : story;
  const accessType = storyObj.access;
  const paywallIcons = (accessType === "login" || accessType === "subscription")
  const imgS3keys = storyObj["hero-image-s3-key"];
  const storyAttributes =
    (storyObj.metadata["story-attributes"] &&
      storyObj.metadata["story-attributes"].storytype &&
      storyObj.metadata["story-attributes"].storytype[0]) ||
    "";
      const defaultImage= useSelector((state) => get(state, ["qt", "config"]))
      const defaultImgState= get(defaultImage, ["publisher-attributes", "defaultImageKey"], "");

  return (
    <Link href={`/${storyObj.slug}`}>
      <div styleName="wrapper" className="type-4">
        {imgS3keys ? (
          <div>
            <HeroImage story={storyObj} aspectRatio={aspectRatio} />
            {storyAttributes && (
              <div styleName="icon-style">
                {storyAttributes === "audio" && <img alt="audio-logo" src="/icons/podcast-icon-white.svg" styleName="custom-img-icon"/>}
                {storyAttributes === "video" && <img alt="video-logo" src="/icons/video-icon-white.svg" styleName="custom-img-icon"/>}
              </div>
            )}

          </div>
        ):
        (
          <div>
            <figure className="story-grid-item-image qt-image-16x9">
              <ResponsiveImage slug={defaultImgState}
                aspectRatio={[16,9]}
                defaultWidth={480} widths={[250,480,640]}
                sizes="(max-width: 500px) 98vw, (max-width: 768px) 48vw, 23vw"
                imgParams={{auto:['format', 'compress']}}
                alt={storyObj.headline} />
          </figure>

            {storyAttributes && (
              <div styleName="icon-style">
                {storyAttributes === "audio" && <img alt="audio-logo" src="/icons/podcast-icon-white.svg" styleName="custom-img-icon"/>}
                {storyAttributes === "video" && <img alt="video-logo" src="/icons/video-icon-white.svg" styleName="custom-img-icon"/>}
              </div>
            )}

          </div>
        )}
      </div>
      {showTimestamp&&<div styleName="section-time-wrapper">
            <TimeStamp story={storyObj} />
            {paywallIcons
              ?<><span>behind paywall</span><i class="ri-star-fill"></i></>
              :<><span>free episodes</span><i class="ri-star-line"></i></>}
          </div>}
    </Link>
  );
};

export default ImageType4;

ImageType4.propTypes = {
  story: object,
  headlineLimit: number,
  widths: array,
  aspectRatio: array,
};
